var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 84,
    viewBox: "0 0 139 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9999 34V73.0495H84.3531H89.8367H95.7425H115.043L123.234 83.0924L137.766 34L70.9999 34Z",
    fill: "#E6570E",
    stroke: "#E6570E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5623 47.402C91.6859 49.3801 90.9441 53.3364 85.8752 57.7872C79.199 56.9217 76.4791 53.9546 75.49 52.2237C75.1191 51.6055 74.9955 51.2346 74.9955 51.111C74.3773 48.8856 75.6136 46.413 77.839 45.7948C80.0644 45.1766 82.5371 46.413 83.1552 48.6383C82.5371 46.413 83.7734 43.9403 85.9988 43.3221C88.2242 42.704 90.6968 43.9403 91.315 46.1657C91.4386 46.1657 91.5623 46.6602 91.5623 47.402Z",
    fill: "#FFB858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.385 48.1633L122.061 54.8395",
    stroke: "#FFB858",
    strokeWidth: 3.9997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.061 48.1633L115.385 54.8395",
    stroke: "#FFB858",
    strokeWidth: 3.9997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8367 51.4373C96.8367 54.35 99.1979 56.7112 102.111 56.7112C105.023 56.7112 107.385 54.35 107.385 51.4373C107.385 48.5245 105.023 46.1633 102.111 46.1633C99.1979 46.1633 96.8367 48.5245 96.8367 51.4373Z",
    fill: "#FFB858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7657 1V40.0495H54.4125H48.929H43.0231L23.7228 40.0495L15.5314 50.0924L1 1L67.7657 1Z",
    fill: "#FFB858",
    stroke: "#FFB858",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2034 14.402C47.0797 16.3801 47.8215 20.3364 52.8905 24.7872C59.5666 23.9217 62.2866 20.9546 63.2756 19.2237C63.6465 18.6055 63.7702 18.2346 63.7702 18.111C64.3883 15.8856 63.152 13.413 60.9266 12.7948C58.7012 12.1766 56.2286 13.413 55.6104 15.6383C56.2286 13.413 54.9922 10.9403 52.7668 10.3221C50.5414 9.70397 48.0688 10.9403 47.4506 13.1657C47.327 13.1657 47.2034 13.6602 47.2034 14.402Z",
    fill: "#E6570E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3811 15.1633L16.7049 21.8395",
    stroke: "#E6570E",
    strokeWidth: 3.9997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7049 15.1633L23.3811 21.8395",
    stroke: "#E6570E",
    strokeWidth: 3.9997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.929 18.4373C41.929 21.35 39.5677 23.7112 36.655 23.7112C33.7423 23.7112 31.3811 21.35 31.3811 18.4373C31.3811 15.5245 33.7423 13.1633 36.655 13.1633C39.5677 13.1633 41.929 15.5245 41.929 18.4373Z",
    fill: "#E6570E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackImg);
export default __webpack_public_path__ + "static/media/feedback-img.fd7f53525a811dd3540c9d1ea0d53aa8.svg";
export { ForwardRef as ReactComponent };